import React from 'react';
import * as _ from 'lodash';
import { AgGridReact } from '@ag-grid-community/react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as LocalStorageUtils from '../../../../../HelperMethods/LocalStorageUtils';
import ActionsColumnRenderer from '../../../../common/ActionsColumnRenderer';
import * as enums from '../../../../../HelperMethods/enums';
import TaskMapper from '../../../../../HelperMethods/Mappers';
import AgGridContainer from '../../../../common/AgGridContainer';
import { CONTAINERS, resetView } from '../../../../common/cardNavigationComponent/cardNavigationRedux';
import TaskAssigneeCard from '../../../../common/taskAssigneeCard/TaskAssigneeCard';
import {
  GRID_OPTIONS,
  LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_VISIBILITY_KEY,
  LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_WIDTH_KEY,
  LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_ORDER_KEY,
  onColumnMoved,
  onColumnResized,
  onDisplayedColumnsChanged,
  TASK_TABLE_COLUMN_MAP,
  TASK_VIEW_TASK_GRID_OPTIONS,
} from '../../../../../HelperMethods/AgGridConstants';
import { RESOURCES } from '../../../../../HelperMethods/role-resource-constants';

class LinkedTaskList extends React.PureComponent {
  getColumnDefs = () => {
    const { columnOrder, columnWidth, columnVisibility } = LocalStorageUtils.getLinkedTaskListTableProperties();

    const clonedColumnsMap = _.cloneDeep(TASK_TABLE_COLUMN_MAP);
    Object.keys(clonedColumnsMap).forEach((key) => {
      if (!_.isNil(columnVisibility) && !_.isNil(columnVisibility[key])) {
        clonedColumnsMap[key].hide = !columnVisibility[key];
      }
    });

    // eslint-disable-next-line no-unused-vars
    for (const [field, column] of Object.entries(clonedColumnsMap)) {
      if (columnWidth[field]) {
        Object.assign(column, { width: columnWidth[field] });
      }
    }

    const columnDefs = columnOrder.map((columnKey) => clonedColumnsMap[columnKey]);
    return {
      columnDefs,
    };
  };

  onCellClicked = (event) => {
    const { resetViewInNavigationComponent } = this.props;
    if (event.colDef.field === 'taskTypeName') {
      const { onEditButtonClicked } = this.props;
      console.log(event.data.id);
      onEditButtonClicked(event.data.id);
    } else if (event.colDef.field === 'assignedToUserName') {
      resetViewInNavigationComponent(CONTAINERS.TASK_VIEW, {
        component: TaskAssigneeCard,
        props: {
          taskId: event.data.id,
          readOnly: true,
        },
      });
    }
  };

  setRowStyle = (params) => {
    if (params.data.priority === enums.TASK_PRIORITY.CRITICAL.text) {
      return {
        color: enums.TASK_PRIORITY.CRITICAL.textColor,
        background: enums.TASK_PRIORITY.CRITICAL.backgroundColor,
      };
    }
    return { background: params.data.isMultipleAssignee ? '#fffbe0' : 'inherit' };
  };

  getFlatTasks = ({ taskList, allAreas, vendorsDict, notificationWatchers, assetLevelsDict }) => {
    const watcherDetailsDict = _.keyBy(notificationWatchers, 'id');
    // show all task for linkedTasks
    return TaskMapper.DbTaskToFlatTask({
      tasks: taskList,
      includeParentTask: true,
      allAreas,
      vendorsDict,
      watcherDetailsDict,
      assetLevelsDict,
    });
  };

  render() {
    const { columnDefs } = this.getColumnDefs();
    const {
      taskList,
      onDeleteButtonClicked,
      allAreas,
      vendorsDict,
      notificationWatchers,
      assetLevelsDict = {},
    } = this.props;
    const rowData = this.getFlatTasks({ taskList, allAreas, vendorsDict, notificationWatchers, assetLevelsDict });
    return (
      <AgGridContainer numberOfRow={(rowData && rowData.length) || 0}>
        <div className="ag-theme-balham" style={{ height: '100%' }}>
          <AgGridReact
            {...GRID_OPTIONS}
            {...TASK_VIEW_TASK_GRID_OPTIONS}
            statusBar={{
              statusPanels: [
                {
                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                  align: 'left',
                },
              ],
            }}
            columnDefs={columnDefs || []}
            rowData={rowData}
            onRowDataChanged={(params) => {
              params.columnApi.autoSizeAllColumns();
            }}
            onCellClicked={this.onCellClicked}
            getRowStyle={this.setRowStyle}
            frameworkComponents={{
              actionsColumnRenderer: ActionsColumnRenderer,
            }}
            context={{
              deleteItem: onDeleteButtonClicked,
              disableDeleteConfirmationModal: true,
              resource: RESOURCES.ENTITY.TASK,
            }}
            onDisplayedColumnsChanged={onDisplayedColumnsChanged(
              LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_VISIBILITY_KEY
            )}
            onColumnMoved={onColumnMoved(LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_ORDER_KEY)}
            onColumnResized={onColumnResized(LOCAL_STORAGE_LINKED_TASK_LIST_TABLE_COLUMN_WIDTH_KEY)}
            icons={{
              groupExpanded: '<i class="fa fa-chevron-down"></i>',
              groupContracted: '<i class="fa fa-chevron-right"></i>',
              menu: '<i class="fa fa-filter"></i>',
              checkboxChecked: '<i class="fa fa-check-square ag-grid-checkbox"></i>',
            }}
            suppressColumnVirtualisation
          />
        </div>
      </AgGridContainer>
    );
  }
}

LinkedTaskList.propTypes = {
  taskList: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEditButtonClicked: PropTypes.func.isRequired,
  onDeleteButtonClicked: PropTypes.func.isRequired,
  allAreas: PropTypes.array,
  vendorsDict: PropTypes.object.isRequired,
  notificationWatchers: PropTypes.arrayOf(PropTypes.object).isRequired,
  assetLevelsDict: PropTypes.object,
  resetViewInNavigationComponent: PropTypes.func.isRequired,
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    resetViewInNavigationComponent: bindActionCreators(resetView, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkedTaskList);
